import { graphql } from '../../graphql/graphql';

export const followPropertyModalFragment = graphql(`
  fragment FollowPropertyModal on FollowPropertyModal {
    subtitle
    image {
      ... on ListingImage {
        alt
        caption
        jpgUri: uri(width: 552, height: 328, imageMode: Crop, progressive: true)
        webpUri: uri(width: 552, height: 328, format: WEBP, imageMode: Crop, progressive: true)
      }
      ... on AerialImage {
        alt
        caption
        uri(width: _420P)
      }
    }
  }
`);
